/*
 * Bang color names from http://www.procato.com/rgb+index/?csv
 */
export const ColorNames = {
  white: "#ffffff",
  red: "#ff0000",
  green: "#00ff00",
  blue: "#0000ff",
  yellow: "#ffff00",
  magenta: "#ff00ff",
  cyan: "#00ffff",
  black: "#000000",
  "pinkish white": "#fff6f6",
  "very pale pink": "#ffe2e2",
  "pale pink": "#ffc2c2",
  "light pink": "#ff9e9e",
  "light brilliant red": "#ff6565",
  "luminous vivid red": "#ff0000",
  "pinkish gray": "#e7dada",
  "pale grayish pink": "#e7b8b8",
  pink: "#e78b8b",
  "brilliant red": "#e75151",
  "vivid red": "#e70000",
  "reddish gray": "#a89c9c",
  "grayish red": "#a87d7d",
  "moderate red": "#a84a4a",
  "strong red": "#a80000",
  "reddish brownish gray": "#595353",
  "dark grayish reddish brown": "#594242",
  "reddish brown": "#592727",
  "deep reddish brown": "#590000",
  "reddish brownish black": "#1d1a1a",
  "very reddish brown": "#1d1111",
  "very deep reddish brown": "#1d0000",
  "pale scarlet": "#ffc9c2",
  "very light scarlet": "#ffaa9e",
  "light brilliant scarlet": "#ff7865",
  "luminous vivid scarlet": "#ff2000",
  "light scarlet": "#e7968b",
  "brilliant scarlet": "#e76451",
  "vivid scarlet": "#e71d00",
  "moderate scarlet": "#a8554a",
  "strong scarlet": "#a81500",
  "dark scarlet": "#592d27",
  "deep scarlet": "#590b00",
  "very pale vermilion": "#ffe9e2",
  "pale vermilion": "#ffd1c2",
  "very light vermilion": "#ffb69e",
  "light brilliant vermilion": "#ff8b65",
  "luminous vivid vermilion": "#ff4000",
  "pale, light grayish vermilion": "#e7c4b8",
  "light vermilion": "#e7a28b",
  "brilliant vermilion": "#e77751",
  "vivid vermilion": "#e73a00",
  "grayish vermilion": "#a8887d",
  "moderate vermilion": "#a8614a",
  "strong vermilion": "#a82a00",
  "dark grayish vermilion": "#594842",
  "dark vermilion": "#593427",
  "deep vermilion": "#591600",
  "pale tangelo": "#ffd9c2",
  "very light tangelo": "#ffc29e",
  "light brilliant tangelo": "#ff9f65",
  "luminous vivid tangelo": "#ff6000",
  "light tangelo": "#e7ae8b",
  "brilliant tangelo": "#e78951",
  "vivid tangelo": "#e75700",
  "moderate tangelo": "#a86d4a",
  "strong tangelo": "#a83f00",
  "dark tangelo": "#593a27",
  "deep tangelo": "#592100",
  "very pale orange": "#fff0e2",
  "pale orange": "#ffe0c2",
  "very light orange": "#ffcf9e",
  "light brilliant orange": "#ffb265",
  "luminous vivid orange": "#ff8000",
  "pale, light grayish brown": "#e7d0b8",
  "light orange": "#e7b98b",
  "brilliant orange": "#e79c51",
  "vivid orange": "#e77400",
  "grayish brown": "#a8937d",
  "moderate orange": "#a8794a",
  "strong orange": "#a85400",
  "dark grayish brown": "#594e42",
  brown: "#594027",
  "deep brown": "#592d00",
  "very brown": "#1d1711",
  "very deep brown": "#1d0e00",
  "pale gamboge": "#ffe8c2",
  "very light gamboge": "#ffdb9e",
  "light brilliant gamboge": "#ffc565",
  "luminous vivid gamboge": "#ff9f00",
  "light gamboge": "#e7c58b",
  "brilliant gamboge": "#e7af51",
  "vivid gamboge": "#e79100",
  "moderate gamboge": "#a8854a",
  "strong gamboge": "#a86900",
  "dark gamboge": "#594627",
  "deep gamboge": "#593800",
  "very pale amber": "#fff8e2",
  "pale amber": "#fff0c2",
  "very light amber": "#ffe79e",
  "light brilliant amber": "#ffd865",
  "luminous vivid amber": "#ffbf00",
  "pale, light grayish amber": "#e7dcb8",
  "light amber": "#e7d08b",
  "brilliant amber": "#e7c251",
  "vivid amber": "#e7ae00",
  "grayish amber": "#a89e7d",
  "moderate amber": "#a8914a",
  "strong amber": "#a87e00",
  "dark grayish amber": "#595442",
  "dark amber": "#594d27",
  "deep amber": "#594300",
  "pale gold": "#fff7c2",
  "very light gold": "#fff39e",
  "light brilliant gold": "#ffec65",
  "luminous vivid gold": "#ffdf00",
  "light gold": "#e7dc8b",
  "brilliant gold": "#e7d551",
  "vivid gold": "#e7ca00",
  "moderate gold": "#a89c4a",
  "strong gold": "#a89300",
  "dark gold": "#595327",
  "deep gold": "#594e00",
  "yellowish white": "#fffff6",
  "very pale yellow": "#ffffe2",
  "pale yellow": "#ffffc2",
  "very light yellow": "#ffff9e",
  "light brilliant yellow": "#ffff65",
  "luminous vivid yellow": "#ffff00",
  "light yellowish gray": "#e7e7da",
  "pale, light grayish olive": "#e7e7b8",
  "light yellow": "#e7e78b",
  "brilliant yellow": "#e7e751",
  "vivid yellow": "#e7e700",
  "yellowish gray": "#a8a89c",
  "grayish olive": "#a8a87d",
  "moderate olive": "#a8a84a",
  "strong olive": "#a8a800",
  "dark olivish gray": "#595953",
  "dark grayish olive": "#595942",
  "dark olive": "#595927",
  "deep olive": "#595900",
  "yellowish black": "#1d1d1a",
  "very dark olive": "#1d1d11",
  "very deep olive": "#1d1d00",
  "pale apple green": "#f7ffc2",
  "very light apple green": "#f3ff9e",
  "light brilliant apple green": "#ecff65",
  "luminous vivid apple green": "#dfff00",
  "light apple green": "#dce78b",
  "brilliant apple green": "#d5e751",
  "vivid apple green": "#cae700",
  "moderate apple green": "#9ca84a",
  "strong apple green": "#93a800",
  "dark apple green": "#535927",
  "deep apple green": "#4e5900",
  "very pale lime green": "#f8ffe2",
  "pale lime green": "#f0ffc2",
  "very light lime green": "#e7ff9e",
  "light brilliant lime green": "#d8ff65",
  "luminous vivid lime green": "#bfff00",
  "pale, light grayish lime green": "#dce7b8",
  "light lime green": "#d0e78b",
  "brilliant lime green": "#c2e751",
  "vivid lime green": "#aee700",
  "grayish lime green": "#9ea87d",
  "moderate lime green": "#91a84a",
  "strong lime green": "#7ea800",
  "dark grayish lime green": "#545942",
  "dark lime green": "#4d5927",
  "deep lime green": "#435900",
  "pale spring bud": "#e8ffc2",
  "very light spring bud": "#dbff9e",
  "light brilliant spring bud": "#c5ff65",
  "luminous vivid spring bud": "#9fff00",
  "light spring bud": "#c5e78b",
  "brilliant spring bud": "#afe751",
  "vivid spring bud": "#91e700",
  "moderate spring bud": "#85a84a",
  "strong spring bud": "#69a800",
  "dark spring bud": "#465927",
  "deep spring bud": "#385900",
  "very pale chartreuse green": "#f0ffe2",
  "pale chartreuse green": "#e0ffc2",
  "very light chartreuse green": "#cfff9e",
  "light brilliant chartreuse green": "#b2ff65",
  "luminous vivid chartreuse green": "#80ff00",
  "pale, light grayish chartreuse green": "#d0e7b8",
  "light chartreuse green": "#b9e78b",
  "brilliant chartreuse green": "#9ce751",
  "vivid chartreuse green": "#74e700",
  "grayish chartreuse green": "#93a87d",
  "moderate chartreuse green": "#79a84a",
  "strong chartreuse green": "#54a800",
  "dark grayish chartreuse green": "#4e5942",
  "dark chartreuse green": "#405927",
  "deep chartreuse green": "#2d5900",
  "very dark chartreuse green": "#171d11",
  "very deep chartreuse green": "#0e1d00",
  "pale pistachio": "#d9ffc2",
  "very light pistachio": "#c2ff9e",
  "light brilliant pistachio": "#9fff65",
  "luminous vivid pistachio": "#60ff00",
  "light pistachio": "#aee78b",
  "brilliant pistachio": "#89e751",
  "vivid pistachio": "#57e700",
  "moderate pistachio": "#6da84a",
  "strong pistachio": "#3fa800",
  "dark pistachio": "#3a5927",
  "deep pistachio": "#215900",
  "very pale harlequin": "#e9ffe2",
  "pale harlequin": "#d1ffc2",
  "very light harlequin": "#b6ff9e",
  "light brilliant harlequin": "#8bff65",
  "luminous vivid harlequin": "#40ff00",
  "pale, light grayish harlequin": "#c4e7b8",
  "light harlequin": "#a2e78b",
  "brilliant harlequin": "#77e751",
  "vivid harlequin": "#3ae700",
  "grayish harlequin": "#88a87d",
  "moderate harlequin": "#61a84a",
  "strong harlequin": "#2aa800",
  "dark grayish harlequin": "#485942",
  "dark harlequin": "#345927",
  "deep harlequin": "#165900",
  "pale sap green": "#c9ffc2",
  "very light sap green": "#aaff9e",
  "light brilliant sap green": "#78ff65",
  "luminous vivid sap green": "#20ff00",
  "light sap green": "#96e78b",
  "brilliant sap green": "#64e751",
  "vivid sap green": "#1de700",
  "moderate sap green": "#55a84a",
  "strong sap green": "#15a800",
  "dark sap green": "#2d5927",
  "deep sap green": "#0b5900",
  "greenish white": "#f6fff6",
  "very pale green": "#e2ffe2",
  "pale green": "#c2ffc2",
  "very light green": "#9eff9e",
  "light brilliant green": "#65ff65",
  "luminous vivid green": "#00ff00",
  "light greenish gray": "#dae7da",
  "pale, light grayish green": "#b8e7b8",
  "light green": "#8be78b",
  "brilliant green": "#51e751",
  "vivid green": "#00e700",
  "greenish gray": "#9ca89c",
  "grayish green": "#7da87d",
  "moderate green": "#4aa84a",
  "strong green": "#00a800",
  "dark greenish gray": "#535953",
  "dark grayish green": "#425942",
  "dark green": "#275927",
  "deep green": "#005900",
  "greenish black": "#1a1d1a",
  "very dark green": "#111d11",
  "very deep green": "#001d00",
  "pale emerald green": "#c2ffc9",
  "very light emerald green": "#9effaa",
  "light brilliant emerald green": "#65ff78",
  "luminous vivid emerald green": "#00ff20",
  "light emerald green": "#8be796",
  "brilliant emerald green": "#51e764",
  "vivid emerald green": "#00e71d",
  "moderate emerald green": "#4aa855",
  "strong emerald green": "#00a815",
  "dark emerald green": "#27592d",
  "deep emerald green": "#00590b",
  "very pale malachite green": "#e2ffe9",
  "pale malachite green": "#c2ffd1",
  "very light malachite green": "#9effb6",
  "light brilliant malachite green": "#65ff8b",
  "luminous vivid malachite green": "#00ff40",
  "pale, light grayish malachite green": "#b8e7c4",
  "light malachite green": "#8be7a2",
  "brilliant malachite green": "#51e777",
  "vivid malachite green": "#00e73a",
  "grayish malachite green": "#7da888",
  "moderate malachite green": "#4aa861",
  "strong malachite green": "#00a82a",
  "dark grayish malachite green": "#425948",
  "dark malachite green": "#275934",
  "deep malachite green": "#005916",
  "pale sea green": "#c2ffd9",
  "very light sea green": "#9effc2",
  "light brilliant sea green": "#65ff9f",
  "luminous vivid sea green": "#00ff60",
  "light sea green": "#8be7ae",
  "brilliant sea green": "#51e789",
  "vivid sea green": "#00e757",
  "moderate sea green": "#4aa86d",
  "strong sea green": "#00a83f",
  "dark sea green": "#27593a",
  "deep sea green": "#005921",
  "very pale spring green": "#e2fff0",
  "pale spring green": "#c2ffe0",
  "very light spring green": "#9effcf",
  "light brilliant spring green": "#65ffb2",
  "luminous vivid spring green": "#00ff80",
  "pale, light grayish spring green": "#b8e7d0",
  "light spring green": "#8be7b9",
  "brilliant spring green": "#51e79c",
  "vivid spring green": "#00e774",
  "grayish spring green": "#7da893",
  "moderate spring green": "#4aa879",
  "strong spring green": "#00a854",
  "dark grayish spring green": "#42594e",
  "dark spring green": "#275940",
  "deep spring green": "#00592d",
  "very dark spring green": "#111d17",
  "very deep spring green": "#001d0e",
  "pale aquamarine": "#c2ffe8",
  "very light aquamarine": "#9effdb",
  "light brilliant aquamarine": "#65ffc5",
  "luminous vivid aquamarine": "#00ff9f",
  "light aquamarine": "#8be7c5",
  "brilliant aquamarine": "#51e7af",
  "vivid aquamarine": "#00e791",
  "moderate aquamarine": "#4aa885",
  "strong aquamarine": "#00a869",
  "dark aquamarine": "#275946",
  "deep aquamarine": "#005938",
  "very pale turquoise": "#e2fff8",
  "pale turquoise": "#c2fff0",
  "very light turquoise": "#9effe7",
  "light brilliant turquoise": "#65ffd8",
  "luminous vivid turquoise": "#00ffbf",
  "pale, light grayish turquoise": "#b8e7dc",
  "light turquoise": "#8be7d0",
  "brilliant turquoise": "#51e7c2",
  "vivid turquoise": "#00e7ae",
  "grayish turquoise": "#7da89e",
  "moderate turquoise": "#4aa891",
  "strong turquoise": "#00a87e",
  "dark grayish turquoise": "#425954",
  "dark turquoise": "#27594d",
  "deep turquoise": "#005943",
  "pale opal": "#c2fff7",
  "very light opal": "#9efff3",
  "light brilliant opal": "#65ffec",
  "luminous vivid opal": "#00ffdf",
  "light opal": "#8be7dc",
  "brilliant opal": "#51e7d5",
  "vivid opal": "#00e7ca",
  "moderate opal": "#4aa89c",
  "strong opal": "#00a893",
  "dark opal": "#275953",
  "deep opal": "#00594e",
  "cyanish white": "#f6ffff",
  "very pale cyan": "#e2ffff",
  "pale cyan": "#c2ffff",
  "very light cyan": "#9effff",
  "light brilliant cyan": "#65ffff",
  "luminous vivid cyan": "#00ffff",
  "light cyanish gray": "#dae7e7",
  "pale, light grayish cyan": "#b8e7e7",
  "light cyan": "#8be7e7",
  "brilliant cyan": "#51e7e7",
  "vivid cyan": "#00e7e7",
  "cyanish gray": "#9ca8a8",
  "grayish cyan": "#7da8a8",
  "moderate cyan": "#4aa8a8",
  "strong cyan": "#00a8a8",
  "dark cyanish gray": "#535959",
  "dark grayish cyan": "#425959",
  "dark cyan": "#275959",
  "deep cyan": "#005959",
  "cyanish black": "#1a1d1d",
  "very dark cyan": "#111d1d",
  "very deep cyan": "#001d1d",
  "pale arctic blue": "#c2f7ff",
  "very light arctic blue": "#9ef3ff",
  "light brilliant arctic blue": "#65ecff",
  "luminous vivid arctic blue": "#00dfff",
  "light arctic blue": "#8bdce7",
  "brilliant arctic blue": "#51d5e7",
  "vivid arctic blue": "#00cae7",
  "moderate arctic blue": "#4a9ca8",
  "strong arctic blue": "#0093a8",
  "dark arctic blue": "#275359",
  "deep arctic blue": "#004e59",
  "very pale cerulean": "#e2f8ff",
  "pale cerulean": "#c2f0ff",
  "very light cerulean": "#9ee7ff",
  "light brilliant cerulean": "#65d8ff",
  "luminous vivid cerulean": "#00bfff",
  "pale, light grayish cerulean": "#b8dce7",
  "light cerulean": "#8bd0e7",
  "brilliant cerulean": "#51c2e7",
  "vivid cerulean": "#00aee7",
  "grayish cerulean": "#7d9ea8",
  "moderate cerulean": "#4a91a8",
  "strong cerulean": "#007ea8",
  "dark grayish cerulean": "#425459",
  "dark cerulean": "#274d59",
  "deep cerulean": "#004359",
  "pale cornflower blue": "#c2e8ff",
  "very light cornflower blue": "#9edbff",
  "light brilliant cornflower blue": "#65c5ff",
  "luminous vivid cornflower blue": "#009fff",
  "light cornflower blue": "#8bc5e7",
  "brilliant cornflower blue": "#51afe7",
  "vivid cornflower blue": "#0091e7",
  "moderate cornflower blue": "#4a85a8",
  "strong cornflower blue": "#0069a8",
  "dark cornflower blue": "#274659",
  "deep cornflower blue": "#003859",
  "very pale azure": "#e2f0ff",
  "pale azure": "#c2e0ff",
  "very light azure": "#9ecfff",
  "light brilliant azure": "#65b2ff",
  "luminous vivid azure": "#0080ff",
  "pale, light grayish azure": "#b8d0e7",
  "light azure": "#8bb9e7",
  "brilliant azure": "#519ce7",
  "vivid azure": "#0074e7",
  "grayish azure": "#7d93a8",
  "moderate azure": "#4a79a8",
  "strong azure": "#0054a8",
  "dark grayish azure": "#424e59",
  "dark azure": "#274059",
  "deep azure": "#002d59",
  "very dark azure": "#11171d",
  "very deep azure": "#000e1d",
  "pale cobalt blue": "#c2d9ff",
  "very light cobalt blue": "#9ec2ff",
  "light brilliant cobalt blue": "#659fff",
  "luminous vivid cobalt blue": "#0060ff",
  "light cobalt blue": "#8baee7",
  "brilliant cobalt blue": "#5189e7",
  "vivid cobalt blue": "#0057e7",
  "moderate cobalt blue": "#4a6da8",
  "strong cobalt blue": "#003fa8",
  "dark cobalt blue": "#273a59",
  "deep cobalt blue": "#002159",
  "very pale sapphire blue": "#e2e9ff",
  "pale sapphire blue": "#c2d1ff",
  "very light sapphire blue": "#9eb6ff",
  "light brilliant sapphire blue": "#658bff",
  "luminous vivid sapphire blue": "#0040ff",
  "pale, light grayish sapphire blue": "#b8c4e7",
  "light sapphire blue": "#8ba2e7",
  "brilliant sapphire blue": "#5177e7",
  "vivid sapphire blue": "#003ae7",
  "grayish sapphire blue": "#7d88a8",
  "moderate sapphire blue": "#4a61a8",
  "strong sapphire blue": "#002aa8",
  "dark grayish sapphire blue": "#424859",
  "dark sapphire blue": "#273459",
  "deep sapphire blue": "#001659",
  "pale phthalo blue": "#c2c9ff",
  "very light phthalo blue": "#9eaaff",
  "light brilliant phthalo blue": "#6578ff",
  "luminous vivid phthalo blue": "#0020ff",
  "light phthalo blue": "#8b96e7",
  "brilliant phthalo blue": "#5164e7",
  "vivid phthalo blue": "#001de7",
  "moderate phthalo blue": "#4a55a8",
  "strong phthalo blue": "#0015a8",
  "dark phthalo blue": "#272d59",
  "deep phthalo blue": "#000b59",
  "bluish white": "#f6f6ff",
  "very pale blue": "#e2e2ff",
  "pale blue": "#c2c2ff",
  "very light blue": "#9e9eff",
  "light brilliant blue": "#6565ff",
  "luminous vivid blue": "#0000ff",
  "light bluish gray": "#dadae7",
  "pale, light grayish blue": "#b8b8e7",
  "light blue": "#8b8be7",
  "brilliant blue": "#5151e7",
  "vivid blue": "#0000e7",
  "bluish gray": "#9c9ca8",
  "grayish blue": "#7d7da8",
  "moderate blue": "#4a4aa8",
  "strong blue": "#0000a8",
  "dark bluish gray": "#535359",
  "dark grayish blue": "#424259",
  "dark blue": "#272759",
  "deep blue": "#000059",
  "bluish black": "#1a1a1d",
  "very dark blue": "#11111d",
  "very deep blue": "#00001d",
  "pale persian blue": "#c9c2ff",
  "very light persian blue": "#aa9eff",
  "light brilliant persian blue": "#7865ff",
  "luminous vivid persian blue": "#2000ff",
  "light persian blue": "#968be7",
  "brilliant persian blue": "#6451e7",
  "vivid persian blue": "#1d00e7",
  "moderate persian blue": "#554aa8",
  "strong persian blue": "#1500a8",
  "dark persian blue": "#2d2759",
  "deep persian blue": "#0b0059",
  "very pale indigo": "#e9e2ff",
  "pale indigo": "#d1c2ff",
  "very light indigo": "#b69eff",
  "light brilliant indigo": "#8b65ff",
  "luminous vivid indigo": "#4000ff",
  "pale, light grayish indigo": "#c4b8e7",
  "light indigo": "#a28be7",
  "brilliant indigo": "#7751e7",
  "vivid indigo": "#3a00e7",
  "grayish indigo": "#887da8",
  "moderate indigo": "#614aa8",
  "strong indigo": "#2a00a8",
  "dark grayish indigo": "#484259",
  "dark indigo": "#342759",
  "deep indigo": "#160059",
  "pale blue violet": "#d9c2ff",
  "very light blue violet": "#c29eff",
  "light brilliant blue violet": "#9f65ff",
  "luminous vivid blue violet": "#6000ff",
  "light blue violet": "#ae8be7",
  "brilliant blue violet": "#8951e7",
  "vivid blue violet": "#5700e7",
  "moderate blue violet": "#6d4aa8",
  "strong blue violet": "#3f00a8",
  "dark blue violet": "#3a2759",
  "deep blue violet": "#210059",
  "very pale violet": "#f0e2ff",
  "pale violet": "#e0c2ff",
  "very light violet": "#cf9eff",
  "light brilliant violet": "#b265ff",
  "luminous vivid violet": "#8000ff",
  "pale, light grayish violet": "#d0b8e7",
  "light violet": "#b98be7",
  "brilliant violet": "#9c51e7",
  "vivid violet": "#7400e7",
  "grayish violet": "#937da8",
  "moderate violet": "#794aa8",
  "strong violet": "#5400a8",
  "dark grayish violet": "#4e4259",
  "dark violet": "#402759",
  "deep violet": "#2d0059",
  "very dark violet": "#17111d",
  "very deep violet": "#0e001d",
  "pale purple": "#e8c2ff",
  "very light purple": "#db9eff",
  "light brilliant purple": "#c565ff",
  "luminous vivid purple": "#9f00ff",
  "light purple": "#c58be7",
  "brilliant purple": "#af51e7",
  "vivid purple": "#9100e7",
  "moderate purple": "#854aa8",
  "strong purple": "#6900a8",
  "dark purple": "#462759",
  "deep purple": "#380059",
  "very pale mulberry": "#f8e2ff",
  "pale mulberry": "#f0c2ff",
  "very light mulberry": "#e79eff",
  "light brilliant mulberry": "#d865ff",
  "luminous vivid mulberry": "#bf00ff",
  "pale, light grayish mulberry": "#dcb8e7",
  "light mulberry": "#d08be7",
  "brilliant mulberry": "#c251e7",
  "vivid mulberry": "#ae00e7",
  "grayish mulberry": "#9e7da8",
  "moderate mulberry": "#914aa8",
  "strong mulberry": "#7e00a8",
  "dark grayish mulberry": "#544259",
  "dark mulberry": "#4d2759",
  "deep mulberry": "#430059",
  "pale heliotrope": "#f7c2ff",
  "very light heliotrope": "#f39eff",
  "light brilliant heliotrope": "#ec65ff",
  "luminous vivid heliotrope": "#df00ff",
  "light heliotrope": "#dc8be7",
  "brilliant heliotrope": "#d551e7",
  "vivid heliotrope": "#ca00e7",
  "moderate heliotrope": "#9c4aa8",
  "strong heliotrope": "#9300a8",
  "dark heliotrope": "#532759",
  "deep heliotrope": "#4e0059",
  "magentaish white": "#fff6ff",
  "very pale magenta": "#ffe2ff",
  "pale magenta": "#ffc2ff",
  "very light magenta": "#ff9eff",
  "light brilliant magenta": "#ff65ff",
  "luminous vivid magenta": "#ff00ff",
  "light magentaish gray": "#e7dae7",
  "pale, light grayish magenta": "#e7b8e7",
  "light magenta": "#e78be7",
  "brilliant magenta": "#e751e7",
  "vivid magenta": "#e700e7",
  "magentaish gray": "#a89ca8",
  "grayish magenta": "#a87da8",
  "moderate magenta": "#a84aa8",
  "strong magenta": "#a800a8",
  "dark magentaish gray": "#595359",
  "dark grayish magenta": "#594259",
  "dark magenta": "#592759",
  "deep magenta": "#590059",
  "magentaish black": "#1d1a1d",
  "very dark magenta": "#1d111d",
  "very deep magenta": "#1d001d",
  "pale orchid": "#ffc2f7",
  "very light orchid": "#ff9ef3",
  "light brilliant orchid": "#ff65ec",
  "luminous vivid orchid": "#ff00df",
  "light orchid": "#e78bdc",
  "brilliant orchid": "#e751d5",
  "vivid orchid": "#e700ca",
  "moderate orchid": "#a84a9c",
  "strong orchid": "#a80093",
  "dark orchid": "#592753",
  "deep orchid": "#59004e",
  "very pale fuchsia": "#ffe2f8",
  "pale fuchsia": "#ffc2f0",
  "very light fuchsia": "#ff9ee7",
  "light brilliant fuchsia": "#ff65d8",
  "luminous vivid fuchsia": "#ff00bf",
  "pale, light grayish fuchsia": "#e7b8dc",
  "light fuchsia": "#e78bd0",
  "brilliant fuchsia": "#e751c2",
  "vivid fuchsia": "#e700ae",
  "grayish fuchsia": "#a87d9e",
  "moderate fuchsia": "#a84a91",
  "strong fuchsia": "#a8007e",
  "dark grayish fuchsia": "#594254",
  "dark fuchsia": "#59274d",
  "deep fuchsia": "#590043",
  "pale cerise": "#ffc2e8",
  "very light cerise": "#ff9edb",
  "light brilliant cerise": "#ff65c5",
  "luminous vivid cerise": "#ff009f",
  "light cerise": "#e78bc5",
  "brilliant cerise": "#e751af",
  "vivid cerise": "#e70091",
  "moderate cerise": "#a84a85",
  "strong cerise": "#a80069",
  "dark cerise": "#592746",
  "deep cerise": "#590038",
  "very pale rose": "#ffe2f0",
  "pale rose": "#ffc2e0",
  "very light rose": "#ff9ecf",
  "light brilliant rose": "#ff65b2",
  "luminous vivid rose": "#ff0080",
  "pale, light grayish rose": "#e7b8d0",
  "light rose": "#e78bb9",
  "brilliant rose": "#e7519c",
  "vivid rose": "#e70074",
  "grayish rose": "#a87d93",
  "moderate rose": "#a84a79",
  "strong rose": "#a80054",
  "dark grayish rose": "#59424e",
  "dark rose": "#592740",
  "deep rose": "#59002d",
  "very dark rose": "#1d1117",
  "very deep rose": "#1d000e",
  "pale raspberry": "#ffc2d9",
  "very light raspberry": "#ff9ec2",
  "light brilliant raspberry": "#ff659f",
  "luminous vivid raspberry": "#ff0060",
  "light raspberry": "#e78bae",
  "brilliant raspberry": "#e75189",
  "vivid raspberry": "#e70057",
  "moderate raspberry": "#a84a6d",
  "strong raspberry": "#a8003f",
  "dark raspberry": "#59273a",
  "deep raspberry": "#590021",
  "very pale crimson": "#ffe2e9",
  "pale crimson": "#ffc2d1",
  "very light crimson": "#ff9eb6",
  "light brilliant crimson": "#ff658b",
  "luminous vivid crimson": "#ff0040",
  "pale, light grayish crimson": "#e7b8c4",
  "light crimson": "#e78ba2",
  "brilliant crimson": "#e75177",
  "vivid crimson": "#e7003a",
  "grayish crimson": "#a87d88",
  "moderate crimson": "#a84a61",
  "strong crimson": "#a8002a",
  "dark grayish crimson": "#594248",
  "dark crimson": "#592734",
  "deep crimson": "#590016",
  "pale amaranth": "#ffc2c9",
  "very light amaranth": "#ff9eaa",
  "light brilliant amaranth": "#ff6578",
  "luminous vivid amaranth": "#ff0020",
  "light amaranth": "#e78b96",
  "brilliant amaranth": "#e75164",
  "vivid amaranth": "#e7001d",
  "moderate amaranth": "#a84a55",
  "strong amaranth": "#a80015",
  "dark amaranth": "#59272d",
  "deep amaranth": "#59000b",
};
